import { extendTheme, type ThemeConfig } from "@chakra-ui/react"

const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: true,
}

const theme = extendTheme({
  config,
  semanticTokens: {
    colors: {
      "bg.table": {
        default: "ui.light",
        _dark: "ui.darkSlate",
      },
      "bg.input": {
        default: "white",
        _dark: "gray.700",
      },
      "border.table": {
        default: "gray.200",
        _dark: "gray.600",
      },
      "text.input": {
        default: "black",
        _dark: "white",
      },
      "main.accent": {
        default: "ui.main",
        _dark: "#A3E635",
      },
      "text.dashboardTitle": {
        default: "ui.main",
        _dark: "#A3E635",
      },
    },
  },
  colors: {
    ui: {
      main: "#145705",
      secondary: "#EDF2F7",
      success: "#48BB78",
      danger: "#E53E3E",
      light: "#FAFAFA",
      dark: "#1A202C",
      darkSlate: "#252D3D",
      dim: "#A0AEC0",
    },
  },
  components: {
    Button: {
      variants: {
        primary: {
          bg: "main.accent",
          color: "ui.light",
          _hover: {
            bg: "#762B00",
          },
          _disabled: {
            bg: "main.accent",
            _hover: {
              bg: "main.accent",
            },
          },
        },
        danger: {
          bg: "ui.danger",
          color: "ui.light",
          _hover: {
            bg: "#E32727",
          },
        },
        wmsDropdown: (props: { colorMode: "light" | "dark" }) => {
          const isDark = props.colorMode === "dark"
          return {
            borderRadius: "xl",
            borderWidth: "1px",
            borderColor: isDark ? "whiteAlpha.400" : "gray.300",
            bg: isDark ? "whiteAlpha.200" : "gray.100",
            color: isDark ? "gray.100" : "gray.800",
            _hover: {
              bg: isDark ? "whiteAlpha.300" : "gray.200",
            },
            _active: {
              bg: isDark ? "whiteAlpha.400" : "gray.300",
            },
            _focusVisible: {
              boxShadow: "none",
              borderColor: isDark ? "green.300" : "green.500",
            },
          }
        },
      },
    },
    Tabs: {
      variants: {
        enclosed: {
          tab: {
            _selected: {
              color: "main.accent",
            },
          },
        },
      },
    },
    Select: {
      variants: {
        wms: (props: { colorMode: "light" | "dark" }) => {
          const isDark = props.colorMode === "dark"
          return {
            field: {
              borderRadius: "xl",
              borderWidth: "1px",
              borderColor: isDark ? "whiteAlpha.400" : "gray.300",
              bg: isDark ? "whiteAlpha.200" : "gray.100",
              color: isDark ? "gray.100" : "gray.800",
              "& > option": {
                backgroundColor: isDark ? "#1A202C" : "#FFFFFF",
                color: isDark ? "#F7FAFC" : "#1A202C",
              },
              "& > optgroup": {
                backgroundColor: isDark ? "#1A202C" : "#FFFFFF",
                color: isDark ? "#F7FAFC" : "#1A202C",
              },
              _hover: {
                bg: isDark ? "whiteAlpha.300" : "gray.200",
              },
              _focusVisible: {
                borderColor: isDark ? "green.300" : "green.500",
                boxShadow: "none",
              },
              _disabled: {
                opacity: 0.7,
                cursor: "not-allowed",
              },
            },
            icon: {
              color: isDark ? "gray.200" : "gray.600",
            },
          }
        },
      },
      defaultProps: {
        variant: "wms",
      },
    },
  },
})
export default theme
